import {TemplateList} from "~/libs/constants/TemplateList"
import type SeoMeta from "~/libs/interfaces/SeoMeta"

export const SeoConfig: Record<TemplateList, SeoMeta> = {
  [TemplateList.POGGERS]: {
    title: 'Poggers.cz',
    description: 'Poggers je komunitní gaming projekt, který se řídí heslem “od hráčů pro hráče”. Kromě čerstvého herního obsahu, jako jsou herní recenze, tématické články, glosy a zpravodajství nabízí především tu nejvíce fresh gaming komunitu na trhu. V ní se čtenáři mohou potkávat, hledat parťáky do her, soutěžit, nahlédnout do zákulisí herní novinařiny a podílet se na komunitních akcích Poggers.',
    author: 'CZECH NEWS CENTER a.s.',
    image: '/img/poggers/og-image.png',
    twitterCard: 'summary_large_image',
    // themeColor: [
    //   {
    //     content: '#4285f4',
    //     media: "(prefers-color-scheme: light)",
    //   },
    //   {
    //     content: '#4285f4',
    //     media: "(prefers-color-scheme: dark)",
    //   },
    // ]
  },
  [TemplateList.MATERIDOUSKA]: {
    title: 'Materidouska.cz',
    description: 'Zábavné i naučné články, hravé úkoly, vtipy, komiksy a čtení na pokračování, k tomu spousta luštění, rébusů a křížovek i tvoření.',
    author: 'CZECH NEWS CENTER a.s.',
    image: '/img/materidouska/og-image.png',
    twitterCard: 'summary_large_image',
    // themeColor: '#4285f4',
  },
  [TemplateList.HEYFOMO]: {
    title: 'HeyFomo',
    description: 'Lifestyle a trendy pro Gen Z',
    author: 'CZECH NEWS CENTER a.s.',
    image: '/img/heyfomo/og-image.png',
    twitterCard: 'summary_large_image',
  }
}